// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"8cb6d19f","213":"18e8a2a4","453":"7b2ffc2e"}[chunkId] + ".chunk.js";
};